<script>
    // core components
    import CorredorView from "../../viewsERP/Corredor.svelte";
  </script>
  
  <div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
      <CorredorView />
    </div>
  </div>